package com.loyola.acessoescola.data


const val RECORD_ID_NAME = "id"
const val NAME_NAME = "a2xmkpa8nhBQ3cHtS-i8ol"
const val CPF_NAME = "bOWP_dMrrdQ6rHW57cISov"
const val PHONE_NAME = "c7W47cGmneW6znjwlcISkE"
const val BOUND_NAME = "c5WPVdGCjix4oXWRtcHSkm"
const val EMAIL_NAME = "cshfOAW5TcS4o5DmoDW7GQ"
const val PHOTO_NAME = "cmW5u1WQjcPkmPW7dcRmoF"

enum class AcessoEscolaRecordFields(val fieldName: String){
    RECORD_ID(fieldName=RECORD_ID_NAME),
    NAME(fieldName=NAME_NAME),
    CPF(fieldName=CPF_NAME),
    PHONE(fieldName=PHONE_NAME),
    BOUND(fieldName=BOUND_NAME),
    EMAIL(fieldName=EMAIL_NAME),
    PHOTO(fieldName=PHOTO_NAME)
}